import { render, staticRenderFns } from "./ExistingGripBarrierList.vue?vue&type=template&id=0b94b83e"
import script from "./ExistingGripBarrierList.vue?vue&type=script&lang=ts"
export * from "./ExistingGripBarrierList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports